<template>
  <adv-setup>
    <div v-if="loaded && present">
      <div class="content-around">
        <warning-msg :message="header.toUpperCase()" :other-class="'alert-error no-border'" />

        <div class="actions">
          <button v-if="showMore" @click="showMore = false" class="secondary" type="button">Mostra meno</button>
        </div>
        <warning-msg
          v-for="(allergy, index) in alwaysShownAllergies"
          v-bind:key="index"
          :message="allergy"
          :other-class="'alert-error no-border'"
          @closeEvent="closeWarning(1)"
        />
        <div v-if="allergies.length > 0">
          <div v-if="showMore">
            <warning-msg
              v-for="(allergy, index) in allergies"
              v-bind:key="index"
              :message="allergy"
              :other-class="'alert-error no-border'"
              @closeEvent="closeWarning(1)"
            />
          </div>
          <div class="actions">
            <button v-if="!showMore && allergies.length > 0" @click="showMore = true" class="secondary" type="button">
              Altre {{ allergies.length }} - mostra di più
            </button>
            <button v-if="showMore" @click="showMore = false" class="secondary" type="button">Mostra meno</button>
          </div>
        </div>
      </div>
    </div>
    <div class="alert" v-if="note_terapie">{{ note_terapie }}</div>
  </adv-setup>
</template>

<script>
import apiConnector from '@/epersonam/apiConnector';
import warningMsg from '../warningMsg';

export default {
  name: 'guestDrugsAllergiesWarning',
  props: {
    guestPeriodDataSetId: Number,
    url: String,
    header: String,
  },
  components: {
    warningMsg,
  },
  data() {
    return {
      numberOfAlwaysShownAllergies: 3,
      loaded: false,
      present: false,
      note_terapie: null,
      allergies: [],
      showMore: false,
    };
  },
  mounted() {
    this.adv_common.openAdvLoader();
    this.checkAllergy();
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    alwaysShownAllergies() {
      return (this.allergies ?? []).splice(0, this.numberOfAlwaysShownAllergies);
    },
    moreAllergies() {
      if (this.showMore) {
        let allAllergies = [...this.allergies];
        return allAllergies.slice(this.numberOfAlwaysShownAllergies);
      } else {
        return null;
      }
    },
  },
  methods: {
    checkAllergy() {
      let finalUrl = this.url;
      if (this.guestPeriodDataSetId) finalUrl = Utils.addGetParam(finalUrl, 'guest_period_data_set_id', this.guestPeriodDataSetId, false);

      apiConnector()
        .get(finalUrl)
        .then(({ data }) => {
          this.allergies = data.allergies;
          this.note_terapie = data.note_terapie;
          this.loaded = true;
          this.present = this.allergies.length > 0;
          this.adv_common.closeAdvLoader();
        })
        .catch(() => {
          this.loaded = true;
          this.adv_common.closeAdvLoader();
          alert('Qualcosa non ha funzionato! Ricaricare la pagina');
        });
    },
    closeWarning(index) {
      this.allergies.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-family: 'Source Sans Pro', sans-serif;
  border: 1px solid #dcdcdc;
  padding: 8px;
}

.black {
  color: black;
}

.no-border {
  border: none;
}

.content-around {
  margin: 2.5px 0px;
  padding: 5px;
  background: #f2dede;
  border-radius: 5px;

  .bold {
    font-weight: bold;
  }
}

.actions {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
